import styled, { keyframes } from 'styled-components';

const cascadeFromAbove = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const cascadeFromBelow = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const CascadingElement = styled.div`
  pointer-events: auto;
`;

const CascadingInner = styled.div`
  opacity: 0;
  transform: ${({ $direction }) =>
    $direction === 'up' ? 'translateY(20px)' : 'translateY(-20px)'};
  animation: ${({ $direction }) =>
      $direction === 'up' ? cascadeFromBelow : cascadeFromAbove}
    0.4s ease-out forwards;
  animation-delay: ${({ $delay }) => $delay || 0}s;
  will-change: transform;
`;

export default CascadingElement;
export { CascadingInner };
